import moment from 'moment';

export default {
  data() {
    return {
      modelEntity: null,
      modelCopy: null,
      entity: '',
      references: [],
      multiReferences: [],
      dates: [],
    };
  },
  methods: {
    getParams() {
      const params = this.getModelCopy();

      if (this.references.length > 0) {
        this.setReferences(this.references);
      }

      if (this.multiReferences.length > 0) {
        this.setMultiReferences(this.multiReferences);
      }

      if (this.dates.length > 0) {
        this.setDates(this.dates);
      }

      return params;
    },
    /**
     *  This ensures it will do a deep clone copy
     * @param force
     * @returns object
     */
    getModelCopy(force = false) {
      if (!this.modelCopy || force) {
        this.modelCopy = JSON.parse(JSON.stringify(this.model))
      }

      return this.modelCopy;
    },

    /**
     * This ensures it will do a deep clone copy
     *
     * @param model
     * @returns {any}
     */
    setModelCopy(model = {}) {
      return JSON.parse(JSON.stringify(model));
    },
    /**
     *
     * @param multiReferences
     * @param object
     */
    async setMultiReferences(multiReferences, object = null) {
      const model = object || this.getModelCopy();
      multiReferences.forEach(({array, key, dates, children = []}) => {
        if (!Array.isArray(key)) {
          key = [key];
        }

        if (Array.isArray(model[array])) {
          return model[array].forEach((refObj) => {
            key.forEach((i) => refObj[i] = refObj[i] ? refObj[i].id : null);

            if (dates) {
              dates.forEach((date) =>
                refObj[date] = refObj[date]
                  ? this.convertDate(refObj[date])
                  : null
              );
            }
          });
        }

        key.forEach((i) => {
          model[array][i] = model[array][i] ? model[array][i].id : null;

          if (children) {
            this.setMultiReferences(children, model[array])
          }
        });
      });
    },
    convertDate(date) {
        return !date ? null : moment(date).format('YYYY-MM-DD');
    },
    /**
     * Set dates on params
     * @param dates
     * @param object
     */
    setDates(dates, object = null) {
      const model = object || this.getModelCopy();
      dates.forEach((ref) => model[ref] = this.convertDate(model[ref]))
    },
    /**
     * Sets references, or dropdowns to be the ID
     * @param references
     * @param object
     */
    setReferences(references, object = null) {
      const model = object || this.getModelCopy();
      references.forEach((ref) => model[ref] = this.getReferenceId(ref, model))
    },
    /**
     * Retrieve an ID field from an object
     * @param fieldName
     * @param object
     * @returns {null}
     */
    getReferenceId(fieldName, object = null) {
      if (!object) {
        object = this.getModelCopy();
      }

      if (!object[fieldName]) {
        return null;
      }

      return object[fieldName].id || null;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      if (!this.modelEntity) {
        console.warn('No model entity set')
        return;
      }

      const params = await this.getParams();
      delete params.id;

      if (!this.validateParams(params)) {
        return false;
      }
      this.loading = true;

      try {
        await this.modelEntity.update(this.id, params);
        this.notifySuccess(this.entity + ' updated');
      } catch (e) {
        this.notifyError(this.entity + ' failed to be updated');
        console.error(e)
      } finally {
        this.modelCopy = null;
        this.loading = false;
      }

      this.postSave();
    },
    postSave() {
      return null
    },
    validateParams() {
      return true;
    }
  },


};
